/**
 * @file     inPageListingClick.ts
 * @readme   ./CLAUDE.md
 * @purpose  Cancel a listing-card anchor click that must open the map sheet
 *           (or another in-page surface) instead of navigating. Modified
 *           clicks stay native so open-in-new-tab still works.
 */

type ListingClick = {
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  button: number;
  preventDefault: () => void;
  stopPropagation: () => void;
};

/** True when the click should follow the href (new tab / new window). */
export function isModifiedListingClick(event: Pick<ListingClick, 'metaKey' | 'ctrlKey' | 'shiftKey' | 'button'>): boolean {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1;
}

/**
 * Cancel the href navigation. Do not stopPropagation: the map panel opens
 * the listing sheet from the wrapping card onClick. NavigationFeedback
 * already ignores defaultPrevented clicks, so the skeleton stays off.
 * Returns true when the click was intercepted.
 */
export function interceptInPageListingClick(event: ListingClick): boolean {
  if (isModifiedListingClick(event)) return false;
  event.preventDefault();
  return true;
}
